module.exports = __webpack_public_path__ + "static/media/combo_7.5dc6be08.png";